import React, {useState} from "react";
import {DatePicker, Form, Modal} from "antd";
import {plannerService} from "../../../../../../../services/planner/planner.service";
import {useTranslate} from "../../../../../../../hooks/translate.hook";
import {PlannerTask} from "../../../../../../../models/planner/planner";

interface PlannerTasksViewAcceptModalProps {
    onClose: () => void;
    task: PlannerTask;
}

export const PlannerTasksViewAcceptModal: React.FC<PlannerTasksViewAcceptModalProps> = ({task, onClose}) => {

    const t = useTranslate();
    const [loading, setLoading] = useState<boolean>(false);
    const [form] = Form.useForm();

    const initialValues = {}

    return (
        <Modal
            visible={true}
            confirmLoading={loading}
            title={t("PLANNER.TASK.NEW_TASK.TITLE")}
            okText={t("OK")}
            cancelText={t("CANCEL")}
            onOk={() => form.submit()}
            onCancel={onClose}
            maskClosable={false}
        >
            <Form
                form={form}
                layout="vertical"
                name={"planner_task_form"}
                initialValues={initialValues}
                onFinish={() => form
                    .validateFields()
                    .then(async values => {
                        setLoading(true);
                        try {
                            await plannerService.approvalPending(task.id, values);
                            onClose();
                        } catch (e: any) {
                            form.setFields(e.response?.data?.fields);
                        } finally {
                            setLoading(false);
                        }
                    })
                }
            >
                <Form.Item
                    label={t("PLANNER.TASK.FIELDS.ESTIMATED_START_DATE")}
                    name="plannedStartDate"
                    rules={[
                        {
                            required: true,
                            message: t(
                                "FROM.ERROR.PLEASE_SELECT_VALUE"
                            ),
                        },
                    ]}
                >
                    <DatePicker disabled={loading}  />
                </Form.Item>
                <Form.Item
                    label={t("PLANNER.TASK.FIELDS.ESTIMATED_END_DATE")}
                    name="plannedEndDate"
                    rules={[
                        {
                            required: true,
                            message: t(
                                "FROM.ERROR.PLEASE_SELECT_VALUE"
                            ),
                        },
                    ]}
                >
                    <DatePicker disabled={loading}  />
                </Form.Item>
            </Form>
        </Modal>
    )
}
